import type { RequestOptions } from '@@/plugin-request/request';
import { type RequestConfig, history } from '@umijs/max';
import { message, notification } from 'antd';
import { getToken, removeToken } from '@/utils/utils';
// 错误处理方案： 错误类型
enum ErrorShowType {
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  AUTH_FAILED = 8,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
export interface ResponseStructure {
  success: boolean;
  data: any;
  message?: string;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

//-- 业务错误处理 helper 函数
const handleBizError = (errorInfo: ResponseStructure) => {
  const { errorMessage, errorCode, showType } = errorInfo;
  console.log(errorInfo);
  switch (showType) {
    case ErrorShowType.WARN_MESSAGE:
      message.warning(errorMessage);
      break;
    case ErrorShowType.ERROR_MESSAGE:
      message.error(errorMessage);
      break;
    case ErrorShowType.NOTIFICATION:
      notification.warning({
        key: errorMessage,
        message: 'NOTIFICATION',
        description: errorMessage,
        showProgress: true,
        pauseOnHover: true,
      });
      break;
    case ErrorShowType.AUTH_FAILED:
      removeToken();
      message.warning('Authentication failed. Your login information has expired. We will automatically redirect you to the login page');
      history.push("/user/login");
      break;
    case ErrorShowType.REDIRECT:
      // TODO: 重定向逻辑（如需要）
      break;
    default:
      message.error(errorMessage || 'Request error, please retry.');
  }
};

/**
 * @name 错误处理
 */
export const errorConfig: RequestConfig = {
  errorConfig: {
    // 错误抛出
    errorThrower: (res) => {
      return res;
    },
    // 服务相关错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      if (error.response) {
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        message.error(`Service response error (${error.response.status})`);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        message.error('None response! Please retry.');
      } else if (error.code === "ERR_CANCELED"){
        // 请求被取消,不发送任何信息
      }else {
        // 发送请求时出了点问题
        message.error('Request error, please retry.');
      }
      return error?.response;
    },
  },
  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      config.headers = {
        ...config.headers,
        'Content-Type': 'application/json',
      };
      // 拦截请求配置，进行个性化处理。
      const token = getToken();
      if (token && !config.headers.authorization) {
        config.headers.authorization = token;
      }
      const url = config?.url;
      return { ...config, url };
    },
  ],
  // 响应拦截器
  responseInterceptors: [
    (response) => {
      const { data } = response as unknown as ResponseStructure;
      if (data?.success === false) {
        // 业务错误处理
        handleBizError(data);
      }
      return response;
    },
  ],
};
